import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getCars = async (params = {}) => {
  const res = await axios.get(`${API}/cars`, { params });
  return res.data;
};

export const getCar = async (slug) => {
  const res = await axios.get(`${API}/cars/${slug}`);
  return res.data;
};

export const createBooking = async (payload) => {
  const res = await axios.post(`${API}/bookings`, payload);
  return res.data;
};

export const getAvailability = async (slug) => {
  const res = await axios.get(`${API}/cars/${slug}/availability`);
  return res.data.ranges;
};
